const position = (el, x, y, half) => {
  el.style.transform = `translate3d(${(x - half).toFixed(2)}px,${(y - half).toFixed(2)}px,0)`;
};

export const createCursorMotion = (host, reduced) => {
  const main = host.querySelector('[data-cursor-main]');
  const ghosts = [...host.querySelectorAll('[data-cursor-ghost]')];
  const pulse = host.querySelector('[data-cursor-pulse]');
  const flash = host.querySelector('[data-cursor-flash]');
  let history = [], previous = null, lastSample = 0, pulseAnimation = null, flashAnimation = null;

  const draw = (point, now) => {
    if (!reduced && previous && now - lastSample >= 28 && Math.hypot(point.x - previous.x, point.y - previous.y) >= 3) {
      history.unshift({ ...previous, time: now });
      history = history.slice(0, 3);
      lastSample = now;
    }
    previous = { ...point };
    position(main, point.x, point.y, 32);
    history = history.filter((p) => now - p.time < 110);
    ghosts.forEach((el, i) => {
      const sample = reduced ? null : history[i];
      if (sample) {
        position(el, sample.x, sample.y, 16);
        el.style.opacity = String(0.10 * (1 - i * 0.2) * (1 - (now - sample.time) / 110));
      } else el.style.opacity = '0';
    });
    return history.length > 0;
  };

  const cancelPulse = () => {
    pulseAnimation?.cancel(); flashAnimation?.cancel();
    pulseAnimation = null; flashAnimation = null;
    host.dataset.pulsing = 'false';
  };
  const click = () => {
    if (reduced || !pulse.animate) return;
    cancelPulse();
    host.dataset.pulsing = 'true';
    pulseAnimation = pulse.animate([
      { transform: 'scale(.5)', opacity: 0.65 },
      { transform: 'scale(.8)', opacity: 0.32, offset: 0.45 },
      { transform: 'scale(1)', opacity: 0 },
    ], { duration: 260, easing: 'cubic-bezier(.16,1,.3,1)' });
    pulseAnimation.onfinish = () => { host.dataset.pulsing = 'false'; };
    flashAnimation = flash.animate([{ opacity: 0.15 }, { opacity: 0 }], { duration: 140, easing: 'ease-out' });
  };
  const reset = () => {
    cancelPulse(); history = []; previous = null; lastSample = 0;
    ghosts.forEach((el) => { el.style.opacity = '0'; });
  };
  return { draw, click, reset };
};